import React, { useEffect } from "react";
import PageHeaderComponent from "../../components/page-components/page-header.component";
import KornspeicherContainer from "../../components/kornspeicher/kornspeicher.container";
import { connect } from "react-redux";
import { fetchReportsStart } from "../../redux/reports/report.actions";

const KornspeicherPage = ({ fetchReportsStart }) => {
  useEffect(() => {
    fetchReportsStart();
  });
  return (
    <div>
      <PageHeaderComponent
        title="Unser Kornspeicher"
        subtitle="Was wir erreicht haben..."
      />
      <KornspeicherContainer />
    </div>
  );
};

const mapDispatchToProps = (dispatch) => ({
  fetchReportsStart: () => dispatch(fetchReportsStart()),
});

export default connect(null, mapDispatchToProps)(KornspeicherPage);
